module.exports = __webpack_public_path__ + "img/play-big.2f1b7836.svg";